<div class="flex h-full flex-col overflow-hidden rounded-2xl bg-white/95 dark:bg-[#0e1726]/95 backdrop-blur border border-gray-100 dark:border-white/10 shadow-xl">
  <!-- Header -->
  <div class="px-4 pt-4 pb-3 border-b border-gray-100 dark:border-white/10">
    <div class="flex items-center justify-between gap-2">
      <h3 class="text-sm font-bold text-[#0e1726] dark:text-white">Vehículos activos</h3>
      <span class="rounded-full bg-primary/20 text-primary px-2.5 py-0.5 text-[11px] font-semibold">{{ vehicles.length }}</span>
    </div>

    <!-- Search -->
    <div class="relative mt-3">
      <svg class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="7" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <input
        [(ngModel)]="searchText"
        type="text"
        placeholder="Buscar placa o marca"
        class="w-full rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 pl-9 pr-3 py-2 text-xs text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
      />
    </div>
  </div>

  <!-- List -->
  <div class="flex-1 overflow-y-auto p-2 space-y-1.5">
    <button
      *ngFor="let v of filtered; trackBy: trackById"
      type="button"
      (click)="onSelect(v)"
      class="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors"
      [ngClass]="
        selectedId === v.id
          ? 'bg-primary/10 ring-1 ring-primary/40'
          : 'hover:bg-gray-100 dark:hover:bg-white/5'
      "
    >
      <!-- Status dot -->
      <span class="relative flex h-2.5 w-2.5 shrink-0">
        <span
          *ngIf="v.status_live === 'MOVING'"
          class="absolute inline-flex h-full w-full animate-ping rounded-full opacity-60"
          [style.backgroundColor]="statusMeta[v.status_live].hex"
        ></span>
        <span class="relative inline-flex h-2.5 w-2.5 rounded-full" [style.backgroundColor]="statusMeta[v.status_live].hex"></span>
      </span>

      <!-- Info -->
      <div class="min-w-0 flex-1">
        <div class="flex items-center justify-between gap-2">
          <span class="text-sm font-semibold text-[#0e1726] dark:text-white truncate">{{ v.plate ? (v.plate | uppercase) : '—' }}</span>
          <span class="text-[11px] font-semibold shrink-0" [style.color]="statusMeta[v.status_live].hex">{{ v.telemetry.speedKmh }} km/h</span>
        </div>
        <div class="text-[11px] text-gray-500 dark:text-white/60 truncate">{{ v.brand }} {{ v.vehicle_model }}</div>
        <div class="flex items-center gap-1 text-[10px] text-gray-400 dark:text-white/40 truncate">
          <svg class="h-3 w-3 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
            <path d="M4 20a8 8 0 0 1 16 0" />
          </svg>
          <span class="truncate">{{ v.driver.name }}</span>
        </div>
      </div>
    </button>

    <div *ngIf="filtered.length === 0" class="py-8 text-center text-xs text-gray-400 dark:text-white/40">Sin resultados</div>
  </div>
</div>
